import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  SendPokemonsInput,
  SendPokemonsOutput,
  WebAppRoutes,
} from "types/web-app";

export const sendPokemons = async (
  accessToken: string,
  input: SendPokemonsInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.SEND_POKEMONS,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<SendPokemonsOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
